import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AppShell from "./AppShell";
import { useModules } from "../../context/ModulesContext";
import { moduleKeyForPath, ModuleDisabledPage } from "./ModuleGuard";
import { getToken } from "../../api/client";

const PrivateRoute = ({ element: Element, withShell = true, ...rest }) => {
  const auth = getToken();
  const location = useLocation();
  const { isEnabled } = useModules();

  if (!auth) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search || ""}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  // Module toggles: pages of a disabled module render a clear explanation
  // instead of a broken page (the backend blocks its API with 403 anyway).
  const moduleKey = moduleKeyForPath(location.pathname);
  const content = moduleKey && !isEnabled(moduleKey) ? <ModuleDisabledPage /> : <Element {...rest} />;
  return withShell ? <AppShell>{content}</AppShell> : content;
};

export default PrivateRoute;
